// Angular
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// Global
import { Global } from '../../utils/global';
// Environment
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private editRoleSource = new BehaviorSubject<any>({});
  editRole = this.editRoleSource.asObservable();

  private headers = new HttpHeaders(
    {
      'user-banca-bt': environment.baseUser,
      'password-banca-bt': environment.basePassword,
    });

  constructor(
    private http: HttpClient
  ) { }

  getModules() {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.get(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Modulo`, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  getRoles() {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.get(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Rol/listaRol`, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  getPermissionsByRole(roleId: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.get(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Permiso/${roleId}`, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  async getPermissionsByModule(data: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
        params: data,
      };
      this.http.get(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Permiso/permisoXModulo`, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  createRole(data: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.post(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Rol`, data, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  updateRole(data: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      this.http.put(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Rol`, data, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  updatePermissionRole(data: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: this.headers,
      };
      return this.http.put(`${Global.SECURITY_BASE_API_URL}api/SeguridadAcierto/Rol/updateRolPermiso`, data, httpOptions).subscribe(
        result => {
          resolve(result);
        }, error => {
          reject(error);
        }
      );
    });
  }

  setRole(data: any): void {
    this.editRoleSource.next(data);
  }
}
